import { render, staticRenderFns } from "./realisations.vue?vue&type=template&id=280b4cb4&scoped=true&"
import script from "./realisations.vue?vue&type=script&lang=js&"
export * from "./realisations.vue?vue&type=script&lang=js&"
import style0 from "./realisations.vue?vue&type=style&index=0&id=280b4cb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280b4cb4",
  null
  
)

export default component.exports